module.exports = __webpack_public_path__ + "static/media/ki.096acc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ki.png
// module id = 1896
// module chunks = 0